import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { OrderEffects } from './order.effects';
import { orderReducer } from './order.reducer';

/**
 * Standalone providers for the `orders` NgRx feature slice (SEOMS-437).
 * Replaces the former `OrderStoreModule` (StoreModule.forFeature +
 * EffectsModule.forFeature), which required the NgModule StoreRootModule and
 * so blocked the app root from moving to `provideStore`.
 */
export function provideOrdersStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('orders', orderReducer),
    provideEffects([OrderEffects]),
  ]);
}
